import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import FoundationStory from './components/FoundationStory';
import MissionVisionValues from './components/MissionVisionValues';
import OutreachGallery from './components/OutreachGallery';
import JourneyTimeline from './components/JourneyTimeline';
import LeadershipSection from './components/LeadershipSection';
import AboutCta from './components/AboutCta';

export default function AboutPage() {
  return (
    <main>
      <Navbar />
      <AboutHero />
      <FoundationStory />
      <MissionVisionValues />
      <OutreachGallery />
      <JourneyTimeline />
      <LeadershipSection />
      <AboutCta />
      <Footer />
    </main>
  );
}
